__webpack_require__.p = "/wp-content/plugins/my-react-app/";